import filter from 'lodash/filter';

export default {
  data() {
    return {
      checkDuplicateEventlevel: false,
    };
  },
  methods: {
    checkValidEventlevel(eventlevelData, eventlevelId) {
      const duplicate = filter(eventlevelData, (item) => item.eventlevelId === eventlevelId);
      if (duplicate.length > 1) {
        this.checkDuplicateEventlevel = true;
      } else {
        this.checkDuplicateEventlevel = false;
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/views/settings/log-analysis/Alarm/popup/js/alarm-setting-mixins.js